import React from "react";

export const RulesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white p-6 overflow-y-auto">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-2">Rules</h1>
        <a href="/" className="text-sm text-gray-400 hover:text-white mb-6 inline-block">
          ← Back to game
        </a>

        <div className="prose prose-invert max-w-none space-y-4 text-sm">
          <h2 className="text-lg font-semibold mt-6">Gameplay</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>You place hexagon tiles on an infinite shared canvas. Each tile is generated by AI from your text prompt.</li>
            <li>To create a tile you need at least one neighboring tile already placed (or have more than 100,000 points).</li>
            <li>Generation cost in points depends on the number of neighbors: 1 neighbor — 350 pts, 2 — 200, 3 — 100, 4 — 50, 5+ — 0.</li>
            <li>You can use 2 Sparks instead of points to generate a tile.</li>
            <li>You receive 600 points once, at first registration. Upvotes, time spent in the game, promo codes, and deleting hexagons do not grant points. Refunds can return points already spent on failed operations.</li>
            <li>Regenerating your own tile costs 25 points. Video animation costs 10 Sparks and requires all 6 neighbors. These two actions are free for admins.</li>
            <li>Sparks purchases and email sending are disabled. Development of the project has ended.</li>
          </ul>

          <h2 className="text-lg font-semibold mt-6">Terms of Service</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>By using the game you confirm you are at least 18 years old.</li>
            <li>We may modify the game and this agreement without prior notice.</li>
            <li>You are responsible for your account and must not share access with third parties.</li>
            <li>Do not use the game for illegal activities or to harm the game or other players.</li>
            <li>All rights to the game belong to the developers. Do not copy, modify, or distribute without permission.</li>
            <li>We are not liable for any damage from use of the game.</li>
            <li>We may block access in case of violation.</li>
            <li>The game uses cookies as described in our <a href="/cookies.txt" target="_blank" rel="noopener noreferrer" className="underline text-gray-300 hover:text-white">Cookie Policy and Email Communications</a>. Email sending has been discontinued. By using the game you agree to that policy.</li>
          </ul>
          <p className="mt-4">By using the game you accept these rules and Terms of Service.</p>
        </div>
      </div>
    </div>
  );
};
